import { UserRole } from "@next-platform/packages-ts-types";

export const USER_ROLES = {
  BETA_USER: UserRole.BETA_USER,

  // Subscription based roles
  SM_BASIC: UserRole.SM_BASIC,
  SM_PREMIUM: UserRole.SM_PREMIUM,
  MINIMAL: UserRole.PAID_MINIMAL,
  BASIC: UserRole.PAID_BASIC,
  PREMIUM: UserRole.PAID_PREMIUM,
  FREE: UserRole.FREE,
} as const;

export const USER_SUBSCRIPTION_STATUS = {
  ACTIVE: "active",
  EXPIRED: "expired",
};

export const DELETE_ACCOUNT_AFTER_SECONDS = 10;

export const IS_ONBOARDING_BANNER_VISIBLE = "firstTimeOnboarding";
export const IS_TARGETED_BANNER_VISIBLE = "isTargetedBannerVisible";

export const GUEST_USER_ID_KEY = "guest_user_id";
export const CHARACTER_RATINGS_KEY = "character_ratings";
export const LASTTIME_FILTERED_CHARACTERS_KEY = "lastTimeFilteredCharacters";
export const USER_LANGUAGE_PREFERENCE_LOCAL_STORAGE_KEY = "user_language_preference";
